import { render, staticRenderFns } from "./NewDVideoUploadEditor.vue?vue&type=template&id=3d558c4b&"
import script from "./NewDVideoUploadEditor.vue?vue&type=script&lang=js&"
export * from "./NewDVideoUploadEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports